import React from 'react'
import { Button, Text, Box } from '@deseretbook/react-ui'
import { useMediaQuery } from '@deseretbook/react-utils'
import UserProfileIcon from '@deseretbook/icons/react/user-profile'

/**
 * The users account/login button that links to the proper location
 *
 * @returns {function} React component
 */
export const AccountButton = () => {
  const isTabletOrLarger = useMediaQuery({ minWidth: 992 })
  const isLoggedIn = window.__USER__ && window.__USER__.loggedIn
  const accountActionText = isLoggedIn ? 'Account' : 'Login'

  return (
    <Button
      type="button"
      color="secondary"
      as="a"
      href={`/${accountActionText.toLowerCase()}`}
      size="small"
      title={accountActionText}
      // To keep the text from being elipsified
      style={{
        minWidth: isTabletOrLarger ? '6.5rem' : '2.5rem',
        marginRight: isTabletOrLarger ? '0.5rem' : '0.25rem',
      }}
    >
      <Box alignItems="center">
        {isTabletOrLarger && (
          <Text
            color="light"
            display="inline-block"
            size="small"
            as="span"
            style={{
              marginRight: '0.25rem',
            }}
          >
            {accountActionText}
          </Text>
        )}
        <UserProfileIcon width="1.5em" height="1.5em" />
      </Box>
    </Button>
  )
}
